import { METRIKA_COUNTER_ID } from '../../constants/metrika';
import type { IMetrikaService, MetrikaVisitParams } from '../../types/common/metrika-types';

class MetrikaService<TGoal extends string> implements IMetrikaService<TGoal> {
  constructor(private readonly counterId: MetrikaCounterId = METRIKA_COUNTER_ID) {}

  init(params?: MetrikaVisitParams): void {
    const visitParams = {
      account_id: params?.accountId,
      user_id: params?.userId,
      roistat_id: params?.roistatId,
    };

    if (window.metrikaInitedCounters?.includes(this.counterId)) {
      window.yaParams = visitParams;
      window.ym?.(this.counterId, 'params', visitParams);
      return;
    }
    window.metrikaInitedCounters = [...(window.metrikaInitedCounters ?? []), this.counterId];
    window.yaParams = visitParams;

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.innerHTML =
      '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n' +
      '        m[i].l=1*new Date();\n' +
      '        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n' +
      '        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n' +
      '      (window, document, "script", "https://cdn.jsdelivr.net/npm/yandex-metrica-watch/tag.js", "ym");\n' +
      '\n' +
      `      ym(${this.counterId}, "init", {\n` +
      '        clickmap:true,\n' +
      '        trackLinks:true,\n' +
      '        accurateTrackBounce:true,\n' +
      '        webvisor:true,\n' +
      '        trackHash:true,\n' +
      '        params: window.yaParams\n' +
      '      });';
    head.appendChild(script);
  }

  reachGoal(goal: TGoal, startPage?: MetrikaStartPage): void {
    if (typeof window.ym !== 'function') {
      return;
    }
    if (!startPage) {
      window.ym(this.counterId, 'reachGoal', goal);
      return;
    }
    window.ym(this.counterId, 'reachGoal', goal, { start_page: { [startPage]: 1 } });
  }
}

export { MetrikaService };
